<template>
  <div class="notification" :class="{ 'is-display-right': right }" v-on-clickaway="away">
    <div class="notification__header" :class="{ 'notification__header--active': click }" @click="toggleDropdown">
      <slot name="fa-icon"></slot>
    </div>
    
    <div class="notification__content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  mixins: [ clickaway ],
  props: {
    displayRight: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      click: false,
      right: this.displayRight
    }
  },
  methods: {
    toggleDropdown () {
      this.click = !this.click
    },
    away () {
      if (this.click) {
        this.click = false;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/element/DropdownNotification.vue